/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Remove_Audio_From_Folder_ConfirmInputs */

const en_dialog_remove_audio_from_folder_confirm = /** @type {(inputs: Dialog_Remove_Audio_From_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to remove this audio from the folder?`)
};

const es_dialog_remove_audio_from_folder_confirm = /** @type {(inputs: Dialog_Remove_Audio_From_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Seguro que quieres eliminar este audio de la carpeta?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to remove this audio from the folder?" |
*
* @param {Dialog_Remove_Audio_From_Folder_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_remove_audio_from_folder_confirm = /** @type {((inputs?: Dialog_Remove_Audio_From_Folder_ConfirmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Remove_Audio_From_Folder_ConfirmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_remove_audio_from_folder_confirm(inputs)
	return en_dialog_remove_audio_from_folder_confirm(inputs)
});